// extracted by mini-css-extract-plugin
export default {"videoWrapper":"videoWrapper__cyqJf","posterElement":"posterElement__LDSqT","fullScreenWrapper":"fullScreenWrapper__bUiS2","posterElementFullScreen":"posterElementFullScreen__NGYHL","background0":"background0__cn6vZ","background1":"background1__kiADm","background2":"background2__HPoUT","background3":"background3__cuDNp","blurred":"blurred__UpETY"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"videoWrapper\":\"videoWrapper__cyqJf\",\"posterElement\":\"posterElement__LDSqT\",\"fullScreenWrapper\":\"fullScreenWrapper__bUiS2\",\"posterElementFullScreen\":\"posterElementFullScreen__NGYHL\",\"background0\":\"background0__cn6vZ\",\"background1\":\"background1__kiADm\",\"background2\":\"background2__HPoUT\",\"background3\":\"background3__cuDNp\",\"blurred\":\"blurred__UpETY\"}";
        // 1787130556857
        var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  